import { createFileRoute } from "@tanstack/react-router";
import { desktopOnlyRoute } from "../components/ui/mobile-availability-page";
import { ResearchDataView } from "../features/eex/research/DataView";
import "../features/eex/research/research.css";

// Research sub-tabs. Each owns its own state; `view` only names the tab.
const RESEARCH_VIEWS = [{ id: "data", label: "Data" }] as const;
type ResearchView = (typeof RESEARCH_VIEWS)[number]["id"];

export const Route = createFileRoute("/eex/research")({
  component: desktopOnlyRoute(EexResearchPage),
  validateSearch: (search: Record<string, unknown>): { view: ResearchView } => ({
    view: RESEARCH_VIEWS.find((view) => view.id === search.view)?.id ?? "data",
  }),
});

function EexResearchPage() {
  const { view } = Route.useSearch();
  const navigate = Route.useNavigate();
  const select = (next: ResearchView) => void navigate({ search: { view: next }, replace: true });
  return (
    <div className="operations-workspace ops-page ops-research min-w-0 space-y-4 p-4">
      <header className="research-heading">
        <h1>Research</h1>
        <p>Power market views for traders, built on day-ahead prices CASCENA stores once for every company.</p>
      </header>
      <div role="tablist" aria-label="Research views" className="research-tabs">
        {RESEARCH_VIEWS.map((tab, index) => (
          <button
            key={tab.id}
            id={`research-tab-${tab.id}`}
            type="button"
            role="tab"
            className="research-tab"
            aria-selected={view === tab.id}
            aria-controls={view === tab.id ? `research-panel-${tab.id}` : undefined}
            tabIndex={view === tab.id ? 0 : -1}
            onClick={() => select(tab.id)}
            onKeyDown={(event) => {
              const step = event.key === "ArrowRight" ? 1 : event.key === "ArrowLeft" ? -1 : 0;
              const target = event.key === "Home" ? 0 : event.key === "End" ? RESEARCH_VIEWS.length - 1 : step ? (index + step + RESEARCH_VIEWS.length) % RESEARCH_VIEWS.length : null;
              if (target === null) return;
              event.preventDefault();
              select(RESEARCH_VIEWS[target]!.id);
              document.getElementById(`research-tab-${RESEARCH_VIEWS[target]!.id}`)?.focus();
            }}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div role="tabpanel" id={`research-panel-${view}`} aria-labelledby={`research-tab-${view}`}>
        {view === "data" && <ResearchDataView />}
      </div>
    </div>
  );
}
